var _path, _rect, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhoneSelector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3863F0",
  d: "M8.013 2.667H19.32c.454 0 .666.552.407.926a6.002 6.002 0 0 0 2.763 9c.99.385 1.843 1.23 1.843 2.291v9.37c0 3.746-1.333 5.08-5.026 5.08H8.013C4.333 29.333 3 28 3 24.253V7.746C3 4 4.333 2.667 8.013 2.667Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 3,
  x: 9.667,
  y: 23,
  fill: "#fff",
  rx: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24.667,
  cy: 7,
  r: 5,
  fill: "#F56B57"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m24.665 8.842-.593-1.428a.585.585 0 0 0-.25-.26c.456-.138.685-.461.685-.968 0-.3-.084-.565-.25-.793C24.055 5.13 23.69 5 23.161 5h-1.495v3.842h.944V7.247h.159c.11 0 .183.014.217.041.039.028.078.09.117.184l.56 1.37h1.001Zm-2.054-1.93v-1.57h.417c.167 0 .298.084.393.251.095.167.142.356.142.568 0 .212-.047.39-.142.534a.445.445 0 0 1-.393.218h-.417ZM25.917 6.036l-.259-.2h-.434v4.275l.936-.125V8.86c.189.039.375.058.56.058.851 0 1.277-.526 1.277-1.578 0-1.053-.429-1.579-1.286-1.579-.262 0-.526.092-.794.276Zm.242 2.405V6.336c.112-.033.201-.05.268-.05.428 0 .643.362.643 1.086 0 .724-.203 1.086-.61 1.086-.133 0-.234-.006-.3-.017Z"
})));
export default SvgPhoneSelector;